const nav = {
  home: '首頁',
  about: '關於',
  freeAngel: '免費 AI Angel',
  livingProfile: '生活檔案',
  qualification: '旅程準備度',
  journey: '旅程',
  weeklyPractice: '每週實踐',
  evidence: '生命證據',
  aiMentor: 'AI 導師',
  library: '書庫',
  membership: '會員',
  dashboard: '儀表板',
  contact: '聯絡我們',
  livingNode: '生命節點',
  portalPractice: '門戶實踐',
  qiHealing: '宇炁療育',

  // Stage indicators — SP003
  stageDiscover: '發現',
  stageUnderstand: '理解',
  stageBegin: '開始',
  stagePractice: '實踐',
  stageContinue: '延續',
};

export default nav;